





import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "bs-label"
})
export default class BsLabelComponent extends Vue {
 
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/bootstrap/bs-label.vue